import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import OrderFormPage from "./OrderFormPage.jsx"

export default function OrderFormEditPage() {
    const params = useParams()
    const orderId = String(params.orderId ?? "").trim()
    useEffect(() => {
        document.activeElement?.blur?.()
        window.scrollTo({ top: 0, left: 0, behavior: "instant" })
    }, [orderId])
    return <OrderFormPage key={`order-form:edit:${orderId}`} />
}

